import { MessageBus } from '@app-velocity/message-bus';

const messageBus = new MessageBus('system');

export const useSavePlugin = () => {
  const handlePluginModal = () => {
    const data = localStorage.getItem('savePluginPopup');

    // fallback
    if (data === 'true') return;

    if (data) {
      try {
        const parsed = JSON.parse(data);
        if (parsed.checked === true) return;
      } catch {
        return;
      }
    }

    messageBus.publish('modal:save-plugin:open');

    localStorage.setItem(
      'savePluginPopup',
      JSON.stringify({
        checked: true,
        date: new Date(),
      })
    );
  };

  return { handlePluginModal };
};
